import { render } from "./page-template.vue?vue&type=template&id=01b1815b&ts=true"
import script from "./page-template.vue?vue&type=script&lang=ts"
export * from "./page-template.vue?vue&type=script&lang=ts"

import "./page-template.vue?vue&type=style&index=0&id=01b1815b&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__